const oneSignal_ = window.OneSignal || []

export default {
	data() {
		return {
			oneSignal: oneSignal_
		}
	}
}